import { dmeConfig, generalSettings } from "dmeditor";
import { DME, DMEData } from "dmeditor";
import { nanoid } from "nanoid";
import { EntityMarkdown } from "./entity";

const definition: DME.Widget = {
  category: "basic",
  icon: "code",
  name: "Markdown",
  type: "markdown",
  events: {
    createBlock: (): DMEData.Block<EntityMarkdown> => {
      return {
        id: nanoid(),
        type: "markdown",
        data: {
          markdownData: "",
          settings: { white: false },
        },
      };
    },
    updateData: () => {},
  },
  settings: [],
};

export default definition;
